"use client";

import { Box, Grid } from "@mui/material";

interface ThreeColumnProps {
  children: React.ReactNode;
  align?: "flex-start" | "center";
}

interface ColumnProps {
  children: React.ReactNode;
}

export function ThreeColumnItem({ children }: ColumnProps) {
  return (
    <Grid size={{ xs: 12, sm: 4 }}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </Grid>
  );
}

export const ThreeColumn = ({ children, align = "flex-start" }: ThreeColumnProps) => {
  return (
    <Grid
      container
      spacing={{ xs: 4, sm: 6 }}
      sx={{
        marginY: {
          xs: 4, // 32px mobile
          sm: 6, // 48px desktop
        },
        alignItems: align,
      }}
    >
      {children}
    </Grid>
  );
};
